import { PropsWithChildren } from "react";

import { PostHogProvider } from "posthog-js/react";

import { POSTHOG_HOST, POSTHOG_KEY } from "@/constants";

const PostHogAnalyticsProvider = ({ children }: PropsWithChildren) => {
  return (
    <PostHogProvider apiKey={POSTHOG_KEY} options={{ api_host: POSTHOG_HOST }}>
      {children}
    </PostHogProvider>
  );
};

export default PostHogAnalyticsProvider;
